export default "__VITE_ASSET__204309d6__"